module.exports = __webpack_public_path__ + "media/images/general/question-03bb5bba5e2d983e873b3de48604f0c9.svg";